import { useEffect, useState } from "react";
import { listLeagues } from "../services/leagueService";

export default function usePublishedLeaguesVisibility() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let active = true;
    let request = 0;
    const refresh = async () => {
      const current = ++request;
      try {
        // Public directory: drafts belonging to the signed-in organizer do not count.
        const result = await listLeagues();
        if (active && current === request) setVisible(result.items.length > 0);
      } catch (_) {
        if (active && current === request) setVisible(false);
      }
    };
    void refresh();
    window.addEventListener("hashchange", refresh);
    return () => {
      active = false;
      window.removeEventListener("hashchange", refresh);
    };
  }, []);

  return visible;
}
